import React, { useContext, useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	EnvelopesWrapper,
	PickerHOC,
	TargetsWrapper,
	Text,
	UiWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { MainModal } from 'components/MainModal/MainModal';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import download from 'assets/images/svgStatic/download.svg';

import { downloadDoc } from 'helpers/downloadDoc';

import { AgentContext } from '../../contexts/agent';
import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';
import * as S from './stylesB2C';

export const ProductCreationFinished = PickerHOC(
	{
		target: {
			arrayItemMatcher: {
				type: 'param',
				paramName: 'targetId',
				itemPropertyPath: 'id',
			},
			sourcePath: 'targets',
			sourceWrapper: TargetsWrapper,
		},
		envelope: {
			sourcePath: 'envelopes',
			sourceWrapper: EnvelopesWrapper,
			arrayItemMatcher: {
				type: 'param',
				paramName: 'envelopeId',
				itemPropertyPath: 'id',
			},
		},
	},
	LoadingScreen,
)(() => {
	const { agent } = useContext(AgentContext);
	const { useHeader, useFooter, useLoading, openModal } = UiWrapper.use();
	const { target, envelope } = PickerHOC.use();
	const { getPreSignedCombinedSignedEnvelopeUrl } = EnvelopesWrapper.use();
	const { t, i18n } = useTranslation();

	const policyData = target?.targetProperties?.find((x) => x.name === 'policyData');
	const [loading, setLoading] = useState();

	console.log('target', target);
	console.log('policyData', policyData);

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('ProductCreationFinished');

	// ESTADO
	const [urlSigned, setUrlSigned] = useState();

	// NAVIGATION
	const next = async () => {
		openModal(
			() => (
				<MainModal
					type="success"
					text="El proceso ha terminado, puedes cerrar la ventana"
				/>
			),
			{
				disableClickAway: true,
				closeButton: true,
				modalClass: isMobile ? 'modal-xl' : 'modal-main',
				key: 'modal-ProductCreationFinished-OK',
			},
		);
	};

	// EFFECTS
	useEffect(() => {
		console.log('📌 envelope', envelope);
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		async function fetchPreSignedUrl() {
			if (envelope?.signStatus === 'SIGNED') {
				const { url: preSignedDocumentUrl } = await getPreSignedCombinedSignedEnvelopeUrl(
					envelope?.id,
				);
				setUrlSigned(preSignedDocumentUrl);
			}
		}
		fetchPreSignedUrl();
	}, [envelope, getPreSignedCombinedSignedEnvelopeUrl]);

	useEffect(() => {
		setTimeout(() => {
			window.location.replace('https://www.allianz.es/');
		}, 300000); // 300000 ms = 5 min
	}, []);

	return (
		<Wrapper showTopSection step={6} title="Documentos y firma">
			<View innerWrapperSt style={{ paddingBottom: 40 }}>
				<Text headingPrimarySt style={{ marginTop: 16 }}>
					¡Gracias! Tu solicitud ha sido tramitada con éxito.
				</Text>
				<View
					rowSt
					justifyStartSt
					itemsCenterSt
					cursorPointerSt
					style={{ marginTop: 40, gap: 10 }}
					onClick={() => downloadDoc(urlSigned, 'signed')}
				>
					<Text
						headingTertiarySt
						style={{ fontWeight: 700, color: CONFIG.colors.primary }}
					>
						Descargar solicitud. Póliza {policyData?.value?.policyNumber}
					</Text>
					<S.IconContainer>
						<img src={download} alt={'download'} style={{ width: '100%' }} />
					</S.IconContainer>
				</View>
				<S.StepWrapperItem>
					<Text headingTertiarySt leftSt>
						Dispones de un plazo de 30 días naturales, a contar desde la fecha de
						contratación, para desistir del presente seguro de vida, en cuyo caso se te
						reintegrará el importe de la prima cobrada sin aplicación de penalización
						alguna.
					</Text>
				</S.StepWrapperItem>
				<S.StepWrapperItem>
					<Text headingTertiarySt leftSt>
						Para ello, puedes llamar al{' '}
						<a
							href={`tel:${agent?.delioPhone ?? CONFIG.contactPhone.value}`}
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: CONFIG.colors.primary }}
						>
							{`${agent?.delioPhoneText ?? CONFIG.contactPhone.label}`}
						</a>
						.
					</Text>
				</S.StepWrapperItem>
				<S.StepWrapperItem>
					<Text headingTertiarySt leftSt>
						Tu póliza estará disponible en un plazo de 24h en tu área de cliente en la
						web de Allianz.
					</Text>
				</S.StepWrapperItem>
				<S.StepWrapperItem>
					<Text headingTertiarySt leftSt>
						El proceso de contratación online ha finalizado.
					</Text>
				</S.StepWrapperItem>
			</View>
			{/* <BackNextButton isBackShown={false} onClickNext={next} nextText="Finalizar" /> */}
		</Wrapper>
	);
});
